import {applyMiddleware} from 'redux';
import * as reduxInjector from 'redux-injector';
import reduxPromiseMiddleware from 'redux-promise-middleware';
import reduxThunk from 'redux-thunk';
import {composeEnhancers} from './devtools';
import reducer from './reducer';

export const injectReducer = reduxInjector.injectReducer;
export const middlewares = [reduxThunk, reduxPromiseMiddleware()].filter(Boolean);
export const store = reduxInjector.createInjectStore(reducer, composeEnhancers(applyMiddleware(...middlewares)));
